export default __webpack_public_path__ + "static/media/login.34e5d361.jpg";